import moment from "moment";
import { useNavigate } from "react-router-dom";
moment.locale("fr");

export default function ProjectGrid({ projects }) {
  const navigate = useNavigate();

  const handleProNavigate = (projects) => {
    navigate(`/admin/projects/${projects}`);
  };
  return (
    <div className="p-6">
      <div
        className="
          flex  items-center justify-center gap-6  scroll-smooth pb-4
            scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100
        "
      >
        {projects.map((project, index) => (
          <button
            key={index}
            onClick={() => handleProNavigate(project._id)}
            className="min-w-[250px] group cursor-pointer bg-white border border-gray-200 rounded-2xl p-5 shadow-sm hover:shadow-lg hover:bg-blue-50 transition-all"
          >
            {/* Icône dossier */}
            <div className="flex items-center justify-center mb-3">
              <div className="bg-blue-100 group-hover:bg-blue-200 p-4 rounded-xl">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-8 h-8 text-blue-600"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 7.5A2.25 2.25 0 015.25 5.25h3.378a2.25 2.25 0 011.59.659l.707.707a2.25 2.25 0 001.59.659h5.484A2.25 2.25 0 0120.25 9.75v8.25A2.25 2.25 0 0118 20.25H6a2.25 2.25 0 01-2.25-2.25V7.5z"
                  />
                </svg>
              </div>
            </div>

            {/* Contenu du projet */}
            <div className="text-center">
              <h3 className="text-base font-semibold text-gray-800 mb-1 truncate">
                {project.name}
              </h3>
              <p className="text-sm text-gray-600 line-clamp-2 mb-3">
                {project.description || "Aucune description"}
              </p>
              <div className="text-xs text-gray-500">
                <span className="block">
                  📅 Début :{" "}
                  {project.startDate
                    ? moment(project.startDate).format("Do MMM YYYY")
                    : "-"}
                </span>
                <span className="block">
                  ⏳ Fin :{" "}
                  {project.endDate
                    ? moment(project.endDate).format("Do MMM YYYY")
                    : "-"}
                </span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
